import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ListaComponent} from "./pages/lista/lista.component";
import {NovaComponent} from "./pages/nova/nova.component";
import {DetalhesComponent} from "./pages/detalhes/detalhes.component";
import {AgendaComponent} from "./pages/agenda/agenda.component";

const routes: Routes = [
  { path: "", component: ListaComponent },
  { path: "novo", component: NovaComponent },
  { path: "detalhes/:id", component: DetalhesComponent },
  { path: "agenda", component: AgendaComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TarefaRoutingModule { }
